import React from 'react';
import Tubesitem from "../../../assets/images/TubesTubesitem.png";
import Fititings from "../../../assets/images/Fititings.png"
import { useTranslation } from 'react-i18next';

function FittingsTubes() {
  const { t } = useTranslation(); // useTranslation hook is added for translation

  const products = [
    {
      name: t('Fittings'),
      description: t('Fittings and valves. During the wine-making process, the most commonly used products happen to be fittings and valves, a wide variety of which you can find at our doorstep.'),
      img: Fititings,
    },
    {
      name: t('Tubes'),
      description: t('Tubes are the main transportation facilities in the winemaking industry. Therefore, it is necessary to make correct steps while choosing them.'),
      img: Tubesitem,
    },
  ];

  return (
    <div className="main-infocontainer">
      {products.map((product, index) => (
        <div className="item-container" key={index}>
          {product.img && <img src={product.img} alt={product.name} />} {/* Conditionally render image */}
          <div className="text-info">
            <h1>{product.name}</h1>
            <p>{product.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default FittingsTubes;
